import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,Input,OnInit,Output,
  EventEmitter,
} from '@angular/core';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import { ITEMS_TYPES } from '@ispm/dynamic-form/constants/ItemsTypes';
import { FormGroup } from '@angular/forms';
import { get, isEmpty } from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AgregationService } from '@ispm-client/modules/aggregator/services';
import { IcodeDisplay, Ifacillity } from '@ispm-client/modules/aggregator/interfaces';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';

@Component({
 selector: 'managing-facility',
 templateUrl: './managing-facility.component.html',
 styleUrls: ['./managing-facility.component.scss'],
 changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('ManagingFacility')
export class ManagingFacilityComponent implements OnDestroy, IWidgetItem,OnInit {
  widgetUpdateValueCallback: (value) => void;

  public widgetConfigPayload: any | { };
  public inputConfig: [DynamicFormItem];
  public widgetFormInstance: FormGroup;
  public listenToDataChange = true;

  private value: any;
  private defaultValue: any = { };
  private options:Array<IcodeDisplay>;
  private destroyed$: Subject<any> = new Subject();
  private isFacilityEnabled:boolean = false;
  private currentActiveFacilities: Array<Ifacillity>;
  private currentManagingFacility: Ifacillity;
  @Output() changeEmit: EventEmitter<string> = new EventEmitter<string>();

  private _valid: boolean = true;
  get valid(){
    return this._valid;
  }
  set valid(valid:boolean) {
    this._valid = valid;
  }
  @Input()
  set widgetConfig(value) {
    this.widgetConfigPayload = get(value, 'widgetPayload', undefined);
    this.initFacilityData();
  }

  set widgetData(widgetData: any) {}

  private _widgetFormInstanceSubmitted: boolean;

  public get widgetFormInstanceSubmitted(){
    return this._widgetFormInstanceSubmitted;
  }

  public set widgetFormInstanceSubmitted(widgetFormInstanceSubmitted: boolean){
    this._widgetFormInstanceSubmitted = widgetFormInstanceSubmitted;
    this._changeDetector.markForCheck();
  };

  constructor(private _changeDetector: ChangeDetectorRef,
    private _aggregatorService: AgregationService) {
  }

  ngOnInit(){

  }
  initFacilityData() {
    this._aggregatorService.getFacilities().pipe(takeUntil(this.destroyed$)).switchMap((facility) => {
      return this._aggregatorService.getCurrentManagedFacility().map((order) => {
        return {isFacilityEnabled:get(facility, 'isFacilityEnabled'),currentActiveFacilities:get(facility, 'currentActiveFacilities'),currentManagingFacility:order}
      });
    }).subscribe((data) => {
        this.isFacilityEnabled = get(data, 'isFacilityEnabled');
        this.currentManagingFacility = get(data, 'currentManagingFacility');
        this.currentActiveFacilities = get(data, 'currentActiveFacilities');
        let currentSelectedFacility = get(data, 'selectedFacilities');
        if(!isEmpty(this.currentManagingFacility) && get(this.currentManagingFacility,'id') != 'all') {
          this.defaultValue = this._aggregatorService.keysRenaming(this.currentManagingFacility,{id:'code',name:'display'});
        } else {
          if(get(currentSelectedFacility,'id') != "all") {
            this.defaultValue =
            this._aggregatorService.keysRenaming(currentSelectedFacility, {
              id: 'code',
              name: 'display'
          })
          }
        }
        if(!isEmpty(this.currentActiveFacilities) && this.isFacilityEnabled){
            this.buildFacilitySelection();
        }
    });
  }

  buildFacilitySelection() {
    this.options = this._aggregatorService.keysRenaming(this.currentActiveFacilities,{id:'code',name:'display'});
    if(!isEmpty(this.defaultValue) || this.options.length == 1){
      this.defaultValue = (this.options.length == 1) ? {managingFacility: this.options[0]} : {managingFacility: this.defaultValue};
    }
    this.updateFacility(this.defaultValue);

    this.inputConfig = [
        Object.assign(
          DynamicFormItem.builder(
            this.widgetConfigPayload.label || '',
            'managingFacility',
            this.widgetConfigPayload.type || ITEMS_TYPES.DROPDOWN
          ).setCssClass(this.widgetConfigPayload.cssClass)
            .setAttributes(this.widgetConfigPayload.attributes)
            .setOptions(this.options)
            .setPlaceholder(this.widgetConfigPayload.placeholder)
            .setRequired(this.widgetConfigPayload.required), this.widgetConfigPayload
        )
    ];
  }

  updateFacility(form) {
    if (form && form.managingFacility && form.managingFacility.code) {
      this.value = { ...form };
      this.changeEmit.emit(form.managingFacility.code);
      if (this.widgetUpdateValueCallback) {
        this.widgetUpdateValueCallback.apply(this, [form.managingFacility.code]);
      }
    }
  }

  updateValidate(valid) {
    this.valid = valid;
    if (!this.valid) {
      /** When clearing the value of managing facility from keyboard,
       * widgetValidator is not automatically emiting the changes to parent on submit */
      this.widgetUpdateValueCallback.apply(this, [undefined]);
    } else if (this.valid && get(this.value, 'managingFacility.code', false)) {
      /** When Valid and has default value, send the default value in callback */
      this.widgetUpdateValueCallback.apply(this, [get(this.value, 'managingFacility.code')]);
    } else {
      // Do Nothing
    }
  }

  widgetValidator(): boolean {
    return this._valid;
  }

  public ngOnDestroy(): void {
      this.destroyed$.next();
      this.destroyed$.complete();
      this._changeDetector.detach();
  }
}
